import moment from 'moment';
import { AnalysisStructure, ArchivedReportsTableData, SavedAnalysisOverview, SeoScoreProgressChartData } from './types';
import { overviewApiDateFormat } from './settings';

export const urlValidation = {
    url: {
        url: {
            message: '^Provide a valid URL',
        },
    },
};

export function groupOverviewsByUrl(overviews: SavedAnalysisOverview[], url: string) {
    const groupedOverviews: Record<string, SavedAnalysisOverview[]> = {};
    groupedOverviews[url] = overviews;
    return groupedOverviews;
}

export function getOverviewApiStartDate(date: moment.Moment): string {
    return moment(date).startOf('month').format(overviewApiDateFormat);
}

export function getOverviewApiEndDate(date: moment.Moment): string {
    return moment(date).endOf('month').format(overviewApiDateFormat);
}

export function getFlatSections(analysisStructure: AnalysisStructure) {
    return Object.values(analysisStructure).flat();
}

export function getSectionKeysFromTitles(analysisStructure: AnalysisStructure, sectionTitles: string[]) {
    const sections = getFlatSections(analysisStructure);
    const sectionKeys: string[] = [];

    sectionTitles.forEach((title) => {
        const foundSection = sections.find((section) => section.title === title);

        if (foundSection) {
            sectionKeys.push(foundSection.key);
        }
    });

    return sectionKeys;
}

export function getSeoScoreProgressChartData(groupedOverviewsByUrl: Record<string, SavedAnalysisOverview[]>): SeoScoreProgressChartData[] {
    let chartData: SeoScoreProgressChartData[] = [];

    for (const url in groupedOverviewsByUrl) {
        chartData = chartData.concat(
            groupedOverviewsByUrl[url].map((overview) => ({
                score: overview.score,
                createdAt: moment(overview.created_at, 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD'),
                url: url,
            }))
        );
    }

    return chartData;
}

export function getArchivedReportsTableData(overviews: SavedAnalysisOverview[]): ArchivedReportsTableData[] {
    return overviews.map((overview, index) => ({
        key: index + 1,
        guid: overview.guid,
        createdAt: moment(overview.created_at, 'YYYY-MM-DDTHH:mm:ss').format('MMM DD, YYYY'),
        score: overview.score,
        passed: overview.passed,
        failed: overview.failed,
        warning: overview.warning,
    }));
}
